export default {"src":"/_next/static/media/17-icon.bae8ea75.svg","height":46,"width":41,"blurWidth":0,"blurHeight":0};